module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-cultura-info-gallery gv-inverted-color-scheme",
    attrs: {
      "id": "gv-cultura-info-gallery"
    }
  }, [_vm._c('div', {
    directives: [{
      name: "draggable",
      rawName: "v-draggable"
    }],
    staticClass: "gv-cultura-info-title gv-color-scheme",
    attrs: {
      "id": "gv-cultura-info-gallery-title"
    }
  }, [_vm._c('strong', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._c('el-button', {
    staticClass: "gv-close gv-color-scheme",
    attrs: {
      "icon": "el-icon-close",
      "type": "button",
      "title": "Chiudi Panello"
    },
    on: {
      "click": _vm.closePanel
    }
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-cultura-info-gallery-body",
    attrs: {
      "id": "gv-cultura-info-gallery-body"
    }
  }, [_vm._c('el-carousel', {
    attrs: {
      "type": "card",
      "interval": _vm.interval,
      "autoplay": _vm.autoplay,
      "indicator-position": "none",
      "arrow": "never"
    }
  }, _vm._l((_vm.gallery), function(item) {
    return _vm._c('el-carousel-item', {
      key: item.id
    }, [_vm._c('div', [_vm._c('div', {
      staticClass: "item"
    }, [_vm._c('div', {
      staticClass: "item__content",
      attrs: {
        "title": item.text
      }
    }, [_vm._v("\n              " + _vm._s(item.label) + "\n            ")]), _vm._v(" "), _vm._c('img', {
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "src": item.imgUrl,
        "title": item.text,
        "alt": item.text
      }
    })])])])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c76d9c34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CulturaInfoGallery.vue
// module id = 903
// module chunks = 39